export default __webpack_public_path__ + "static/1-5-0-0-9b586a87bb06dce08c64620d3f65c22a.jpg";